var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2526 8.71494L20.1603 11.6494M15.3141 22.409H23.0681M7.56007 18.4964L6.59082 22.409L10.4678 21.4309L21.6976 10.098C22.061 9.73118 22.2651 9.23368 22.2651 8.71494C22.2651 8.1962 22.061 7.6987 21.6976 7.33184L21.5309 7.1636C21.1673 6.79685 20.6744 6.59082 20.1603 6.59082C19.6463 6.59082 19.1533 6.79685 18.7898 7.1636L7.56007 18.4964Z",
    stroke: "#000",
    strokeWidth: 0.988636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.928535dee842b574084b413aa6d6a2d5.svg";
export { ForwardRef as ReactComponent };